
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import { IRect, IAnnotation, ITag, ITaggedRect } from '@/types';
import { Prop } from 'vue-property-decorator';
import Transcription from '../../store/modules/transcription';
import store from '@/store/store';

const trscModule = getModule(Transcription, store);
@Component
export default class TaggingDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  @Prop(Object)
  data!: ITaggedRect;
  tags: { [text: string]: boolean } = {};
  tagInput = '';

  get show() {
    return this.value;
  }
  set show(value) {
    this.init();
    this.$emit('input', value);
  }

  get tagTexts() {
    const texts = [];
    for (let tag in this.tags) {
      if (this.tags[tag]) texts.push(tag);
    }
    return texts;
  }

  async restoreTags() {
    for (let id in this.data.tagIds) {
      if (this.data.tagIds[id]) {
        //const tag = await trscModule.getTag(id);
        //this.tags[tag.text] = true;
      }
    }
  }

  init() {
    if (this.data) this.restoreTags();
    this.tags = {};
    this.tagInput = '';
    this.data.share = true;
  }

  addTag() {
    this.tags[this.tagInput] = true;
    this.tagInput = '';
  }

  close(text: string) {
    this.tags = Object.assign({}, this.tags);
  }

  async save() {
    const tagIds = await Promise.all(
      this.tagTexts.map(async (text) => {
        //return await trscModule.fetchOrCreateTag(text);
      }),
    );
    this.data.tagIds = {};
    tagIds.forEach((id) => {
      //this.data.tagIds[id] = true;
    });
    this.data.text = this.tagTexts.join(' ');
    //trscModule.saveTaggedRect({ rect: this.data });
    this.show = false;
  }

  async remove() {
    this.show = false;
    //return await trscModule.removeTaggedRect(this.data.id!);
  }

  cancel() {
    this.show = false;
  }
}
